import { ButtonPrimaryLink } from "../../elements";
import { Section } from "../index";

import { CookiebotModificationWrapper } from "./styles";

const handleChangeCookies = () => {
  if (!window.Cookiebot) return;
  window.Cookiebot.renew();
};

export const CookiebotModification = ({ buttonLabel, displaySetting }) => {
  return (
    <Section
    displayMode={displaySetting?.displayMode}
      smallMargin={displaySetting?.smallBottomMargin}
    >
      <CookiebotModificationWrapper>
        {buttonLabel && (
          <ButtonPrimaryLink onClick={handleChangeCookies}>
            {buttonLabel}
          </ButtonPrimaryLink>
        )}
      </CookiebotModificationWrapper>
    </Section>
  );
};

export default CookiebotModification;
